import { ProductSyncRequest } from "../components/artist-components/view-consignment/view-consignment.component";
import { ArtTypeService } from "../Services/art-type.service";
import { SetupItems } from "./setupItems";
import { ProductSyncedOnPlatformDTO } from "./viewartistproductresponse.model";

 export class ArtistProduct  {
  Id!: string;
  ArtistProductId!: string;
  SerialNumber!: string;
  ArtistId!: string;
  Name!: string;
  ArtistRevenue!: number;
  ArtistShortDescription!: string;
  ArtistLongDescription!: string;
  ArtistSocialMediaDescription!: string;
  ProductImageFile?: File;
  ProductImgUrl?: string;
  ResizedImageUrl?: string;
  Length?: number;
  Width?: number;
  Height?: number;
  Weight?: number;
  Category!: string;
  SeriesId?: string | null;
  ClayId?: string | null;
  CreatedDate!: Date;
  IsActive?: boolean;
  ArtTypeId!: string;
  Comment!: string;
  // Helper Properties
  ArtTypeName!: string;
  ArtTypeDescription?: string;
  IsAccepted!: boolean;
  CategoryName?: string;
  CategoryDescription?: string;
  SeriesName?: string;
  SeriesDescription?: string;
  MaterialName?: string;
  MaterialDescription?: string;
  ArtistProductLog: string[] = [];
  IsSyncToSquarePos!: boolean;
  IsSyncToShopify!: boolean;
  IsSyncToWooCommerce!: boolean;
  IsSyncToWix!: boolean;
  IsSyncToSquareSpace?:boolean;
  ArtistProductLogs: ArtistProductLogResponse[] = [];
  ArtistProductImages: string[] = [];
  CategoryDto?: any;
  ArtTypeDto?: any;
  //Newly added from API
  CreatedBy?: string | null;
  ModifiedBy?: string | null;
  ModifiedDate?: Date;
  IsDeleted?: boolean;
  DeletedDateTime?: Date | null;
  DeletedBy?: string | null;
  IsSoldByArtist?: boolean;
  SoldDate?: Date;
  SoldOnPlateform?: string | null;
  TargertPlateFormSoldProductCurrencySymbol?: string | null;
  ExchangeRateOnSoldProduct?: number;
  TargetPlateFormSoldPrice?: number;
  SeriesDto?: any;
  ClayDto?: any;
  SelectedGlazes!: any;  
  ProductGlazeDto?: any;
  ArtistProductImageDto?: any[];
  ProductSyncedOnPlatformDTOs?: ProductSyncedOnPlatformDTO[];
  //Additional Information Properties
  FurtherDetail?: string | null;
  CurrentLocation?: string | null;
  FramingDetail?: string | null;
  Genre?: string | null;
  CreationContext?: string | null;
  Arrangement?: string | null;
  Place_Sold?: string | null;
  Sold_Date?: Date | null;
  Sold_Price?: number | null;
  Commission_Percentage?: number | null;
  Commission_Amount?: number | null;
  CollectionId?: string | null;
  Collection?: string | null;
  CollectionComment?: string | null;
  Exhibition_History_Provinance?: string | null;
  Additional_Exhibition_Notes?: string | null;
  Recognition?: string | null;
  Additional_Comment?: string | null;
  Online_link?: string | null;
  GalleryId?: string | null;
  GalleryName?: string | null;
  GalleryUserName?: string | null;
  IsSold?: boolean;
  Material?: string | null;
  ProductImagesUrls?: string[] | null;
  BodyOfWork?: string | null;

}




export class ArtistProductLogResponse {
  ActionDate!: string;
  ArtistProductId!: string;
  Message!: string;
}

export class ArtistProductImage {
  Id!: string;
  ArtistProductId!: string;
  ImageUrl!: string;
  IsGalleryImg!: boolean;
  hovered!: boolean;
}
